import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';
import { TicketValidationStatus } from '../../entity/TicketValidationStatus';
import { TicketResponse } from '../../entity/TicketResponse';
import { Ticket } from '../../entity/Ticket';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { TicketValidatorService } from '../../service/ticket-validator.service';
import { environment } from 'src/environments/environment';
import { TicketSaleService } from 'src/app/service/ticket-sale.service';
import { NgxSpinnerService } from "ngx-spinner";
import { finalize, Observable } from 'rxjs';


@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements AfterViewInit {

  @Input() mode: string = "validate";

  @ViewChild('scanner', { static: false })
  scanner!: ZXingScannerComponent;

  allowedFormats = [ BarcodeFormat.QR_CODE, BarcodeFormat.EAN_13, BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX];

  ticketResponse: TicketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;

  offline: boolean = false;

  private lastReadTime: Date = new Date();

  devices: MediaDeviceInfo[] = [];

  permission!: boolean;

  private isWaitingResponse: boolean = false;

  constructor(private spinner: NgxSpinnerService, private ticketValidatorService: TicketValidatorService, private ticketSaleService: TicketSaleService) { 
  }

  ngAfterViewInit(): void {
    this.offline = this.ticketValidatorService.isOfflineMode();
    this.scanner.askForPermission();
  }

  public onCamerasFound(devices: MediaDeviceInfo[]): void{
    this.devices = devices;
    this.devices.forEach((device) => console.log("Found devices: "+device.label + " | " + device.kind));
  }

  public changeCamera(device: MediaDeviceInfo | undefined): void {
    this.scanner.device = device;
  }

  public scanSuccessHandler(result: string): void {
    this.spinner.show();
    if(!this.isWaitingResponse && (new Date(this.lastReadTime.getTime() + environment.SCANNER_READ_LOCK_SECONDS) < new Date())){
      this.isWaitingResponse = true;
      this.reset();
      this.lastReadTime = new Date();
      this.measureMetrics();
      this.handleTicket(result).pipe(finalize(() => this.isWaitingResponse = false))
      .subscribe(data => {
        this.ticketResponse = data;
        this.spinner.hide();
      });
    }
  }

  public reset(){
     this.ticketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;
  }

  private handleTicket(ticketToken: string): Observable<TicketResponse> {

      var ticket = { validity_token: ticketToken } as Ticket;

      if(this.mode == "validate"){
        return this.ticketValidatorService.validateTicket(ticket);
      }

      if(this.mode == "sale"){
        return this.ticketSaleService.sellTicket(ticket);
      }

      return new Observable<TicketResponse>(subscriber => {
        subscriber.error("Invalid mode");
      });
  }


  private measureMetrics(): void {
    localStorage.setItem("scan_counter" , (parseInt(localStorage.getItem("scan_counter") || "0") + 1).toString() );
  }

}
